module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "interview_wrapper"
  }, [_c('step-status', {
    staticClass: "mt55",
    attrs: {
      "step": _vm.$route.meta.step
    }
  }), _vm._v(" "), (_vm.$route.query.status == "Reschedule") ? _c('h1', [_vm._v("\n    Hi " + _vm._s(_vm.full_name) + ","), _c('br'), _vm._v("\n    Thank you for your application to teach with HAWO!"), _c('br'), _vm._v(" We’ve received your information and requested interview time."), _c('br'), _vm._v(" Below, please find the confirmation for your interview, and some further information regarding our interview and demo process.")]) : _vm._e(), _vm._v(" "), (_vm.$route.query.status == "Schedule") ? _c('h1', [_vm._v("Dear " + _vm._s(_vm.full_name) + ",we've assigned an interviewer for you, please click the \"Schedule\" button below to book an appointment with your interviewer.")]) : _vm._e(), _vm._v(" "), (_vm.$route.query.status == "canceled") ? _c('h1', [_vm._v("Dear " + _vm._s(_vm.full_name) + ", you've cancelled your scheduled interview time. You may request a new appointment.")]) : _vm._e(), _vm._v(" "), (_vm.$route.query.status == "rescheduled") ? _c('h1', [_vm._v("Hi " + _vm._s(_vm.full_name) + ", your interview appointment has been rescheduled .")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "schedule"
  }, [_c('h4', [_vm._v("Your Interview Schedule")]), _vm._v(" "), _c('div', {
    staticClass: "schedule_de clearfix"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('ul', [_c('li', {
    staticClass: "clearfix"
  }, [_c('span', {
    staticClass: "schedule_de_tit"
  }, [_vm._v("Time Zone：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.time_zone))])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('span', {
    staticClass: "schedule_de_tit"
  }, [_vm._v("Date & Time：")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.interviewer_date))])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('span', {
    staticClass: "schedule_de_tit"
  }, [_vm._v("Interviewer：")]), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(_vm.interviewer_name))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.interviewer_zoom),
      expression: "interviewer_zoom"
    }]
  }, [_vm._v("Zoom account : " + _vm._s(_vm.interviewer_zoom))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.interviewer_email),
      expression: "interviewer_email"
    }]
  }, [_vm._v("Email : " + _vm._s(_vm.interviewer_email))])])]), _vm._v(" "), _c('li', {
    staticClass: "clearfix"
  }, [_c('span', {
    staticClass: "schedule_de_tit"
  }, [_vm._v("Where：")]), _vm._v(" "), _c('p', [_vm._v("Your interview will be conducted on Zoom.")]), _vm._v(" "), _c('p', {
    staticClass: "interview_click"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.urls.zoomPdfLink,
      "download": "zoom.pdf"
    }
  }, [_vm._v("Click here")]), _vm._v(" "), _c('span', [_vm._v("to download Zoom.")])]), _vm._v(" "), _c('p', {
    staticClass: "interview_click"
  }, [_vm._v("Please check your email inbox or spam folder for further instructions from your recruiter.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Kindly contact your recruiter since you've already rescheduled/cancelled once.",
      "placement": "right",
      "disabled": _vm.canReschedule
    }
  }, [_c('a', {
    staticClass: "style reschedule",
    class: {
      dis: !_vm.canReschedule
    },
    on: {
      "click": _vm.showPop
    }
  }, [_vm._v(_vm._s(_vm.reschedule_inner))])]), _vm._v(" "), (_vm.interviewer_date) ? _c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Kindly contact your recruiter since you've already rescheduled/cancelled once.",
      "placement": "right",
      "disabled": _vm.canReschedule
    }
  }, [_c('a', {
    staticClass: "style cancel",
    class: {
      dis: !_vm.canReschedule
    },
    on: {
      "click": _vm.cancel_apo
    }
  }, [_vm._v("Cancel Appointment")])]) : _vm._e(), _vm._v(" "), (_vm.need_help) ? _c('a', {
    staticClass: "need_help",
    attrs: {
      "href": ("mailto:" + _vm.need_help)
    }
  }, [_vm._v("Have questions? Email here")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "preparation"
  }, [_c('h4', [_vm._v("Interview details")]), _vm._v(" "), _c('div', {
    staticClass: "preparation_de"
  }, [_c('p', [_vm._v("Interview (20 minutes): The interview gives us a chance to learn more about you and your teaching experience.")]), _vm._v(" "), _c('p', [_vm._v("Demo class (15 minutes): The demo class gives us a chance to observe your teaching abilities. You should be prepared to teach a lesson to your interviewer, as if he or she is a 5 years old student.")]), _vm._v(" "), _c('p', [_vm._v("If you have any questions regarding your interview or demo, please feel free to contact your interviewer directly via email "), _c('a', {
    attrs: {
      "href": ("mailto:" + _vm.interviewer_email)
    }
  }, [_vm._v(_vm._s(_vm.interviewer_email))]), (_vm.interviewer_zoom) ? [_vm._v(" or Zoom (live: " + _vm._s(_vm.interviewer_zoom) + ")")] : _vm._e(), _vm._v(". ")], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "preparation"
  }, [_c('h4', [_vm._v("Material and Preparations:")]), _vm._v(" "), _c('div', {
    staticClass: "preparation_de"
  }, [_c('p', [_vm._v("Click "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.urls.interviewPdfLink,
      "download": "nademomaterial_20180818.pdf"
    }
  }, [_vm._v("here")]), _vm._v(" to download the lesson material that you’ll be teaching in your demo class. If you cannot access the previous link, copy the following link into your browser: ")]), _vm._v(" "), _c('p', [_vm._v("http:" + _vm._s(_vm.urls.interviewPdfLink))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("@img/KEOT.jpg"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.reschedule_show),
      expression: "reschedule_show"
    }],
    staticClass: "pop"
  }, [_c('reschedule', {
    attrs: {
      "time-zone": _vm.options,
      "scheduled-time-zone": _vm.time_zone,
      "scheduled-interviewer-date": _vm.interviewer_origin_date,
      "interviewer-id": _vm.interviewer,
      "sureHandler": _vm.confirmOpen
    }
  })], 1), _vm._v(" "), _c('cancel-confirm', {
    ref: "cancelConfirm"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "//www.jobs2careers.com/conversion3.php?p=3857",
      "width": "1",
      "height": "1"
    }
  }), _vm._v(" "), (_vm.$route.query.status == "assigned") ? _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('img', {
    staticStyle: {
      "border-style": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "alt": "",
      "src": "//www.googleadservices.com/pagead/conversion/852175291/?label=dFR5CIzryngQu9OslgM&guid=ON&script=0"
    }
  })]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Demo tips")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("The provided demo material is structured for a typical 25-minute class. You should teach it as if your demo class were to last for 25 minutes, although your interviewer will stop you early.")]), _vm._v(" "), _c('li', [_vm._v("As this interview is for an online teaching position, please be prepared with a clutter-free space, proper lighting,professional attire, and proper positioning in the center of the camera.")]), _vm._v(" "), _c('li', [_vm._v("Your interviewer will have the same lesson material on hand.")]), _vm._v(" "), _c('li', [_vm._v("Remember: you’ll be teaching kids, so be happy, engaging, and excited. Putting on a smile goes a long way! Incorporating helpful body language and gestures into your lesson is key for communicating with students who have little knowledge of English.")]), _vm._v(" "), _c('li', [_vm._v("Have fun! Keeping your lesson entertaining and interesting helps students learn quickly.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92cf4a36"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/interview/interview.vue
// module id = 864
// module chunks = 1